(function ($, undefined) {
    'use strict';

    let submittingForm = false;

    var submitDisplayJobForm = function (e) {
        e.preventDefault();
        const form = $(".volunteer-interest-submit-form");

        //$('.js-form-error-message', form).hide();
        Fw.component.models().form.validateForm(form);
        if (!form.hasClass('has-error') && !submittingForm) {
            if ($('.hide-next-field[name=field12]', form).prop('checked')) {
                $('[name=field13]', form).val('');
            }
            
            submittingForm = true;
            form.submit();
        }
    };
    
    var showNextField = function(e) {
        var el = e.currentTarget;
        if (el.checked) {
            $(el).closest('.toggle-next-field-ctn').next('.next-field-ctn').slideDown(300);
        }
    };
    
    var hideNextField = function(e) {
        var el = e.currentTarget;
        if (el.checked) {
            $(el).closest('.toggle-next-field-ctn').next('.next-field-ctn').slideUp(300);
        }
    };

    var init = function () {
        $('.volunteer-interest-form-submit-btn').on('click', submitDisplayJobForm);
        $(".show-next-field").on("change", showNextField);
        $(".hide-next-field").on("change", hideNextField);

    };

    $(window).ready(init);

})(jQuery);